import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goods_drawer_basic',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleId: [Number, String],
    prepend: {
      type: String,
      default: '点'
    } //单位
  },
  computed: {
    goodsList: function goodsList() {
      return this.value.default_value;
    }
  }
};